import { push } from 'connected-react-router';
import { SET_ONLINE_STATUS } from './constants';
import { setShopStatus } from '../Dashboard/actions';

export const setOnlineStatus = (shopId, isOnline, idToken) => {
  return async (dispatch) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${idToken}`);
    headers.append('Content-type', 'application/json');

    const data = { isOnline };

    const options = {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    }

    const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/shops/status/${shopId}`, options)

    if (response.status === 200) {
      dispatch({ type: SET_ONLINE_STATUS, payload: isOnline });
      dispatch(setShopStatus(isOnline));
    } else if (response.status === 401) {
      dispatch(push('/login'));
      return;
    }
  }
};